import React from "react";

export default function StatusPill({ status, daysLate }) {
  const s = (status || "").toLowerCase();
  const map = {
    paid: { cls: "pill-paid", label: "Paid" },
    due: { cls: "pill-due", label: "Due" },
    overdue: { cls: "pill-overdue", label: daysLate ? `Overdue · ${daysLate}d` : "Overdue" },
    upcoming: { cls: "pill-upcoming", label: "Upcoming" },
    closed: { cls: "pill-closed", label: "Closed" },
    active: { cls: "pill-upcoming", label: "Active" },
  };
  const cfg = map[s] || { cls: "pill-closed", label: status || "—" };
  return (
    <span
      data-testid={`status-pill-${s}`}
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold tabular ${cfg.cls}`}
    >
      {cfg.label}
    </span>
  );
}
